import { ROUTES } from '@/src/utils/routes'

/**
 * Restaurant master list route (`/app/restaurant`). Used by breadcrumb helpers and other chrome;
 * the BHYBE primary rail is always visible regardless of route.
 */
export function isRestaurantMasterListRoute(pathname: string): boolean {
  return pathname === ROUTES.RESTAURANT || pathname === `${ROUTES.RESTAURANT}/`
}
